/**
 * @enum OperatorType Different type of operator used in validation & show decision
 */
enum OperatorType {
  EQUAL = "=",
  NOT_EQUAL = "!=",
  IN = "in",
  LESS_THAN = "<",
  GREATER_THAN = ">",
  LESS_THAN_EQUAL_TO = "<=",
  GREATER_THAN_EQUAL_TO = ">=",
  AND = "and",
  OR = "or"
}

export default OperatorType;
